<template>
  <DbPage
    class="flex flex-col h-screen max-width-full justify-between"
    :class="isWhitePage ? 'bg-white' : 'bg-gray-100'"
  >
    <menu-items></menu-items>
    <DbHeader
      class="bg-white fixed z-20 top-0 min-h-[50px] w-full border-b"
      :class="isWhitePage ? 'shadow-xs' : 'shadow-xl'"
    >
      <div class="pt-2">
        <AppHeader :header="$t(`main.${$route.name}`)"></AppHeader>
      </div>
    </DbHeader>
    <menu-items></menu-items>
    <div
      class="py-2 px-2 mt-[60px] pb-[100px] z-5 overflow-none"
      :class="isWhitePage ? 'bg-white' : 'bg-gray-100'"
    >
      <router-view />
    </div>

    <DbFooter
      class="bg-slate-700 fixed bottom-0 z-20 shadow-xl min-h-[80px] w-full"
    >
      <div class="pt-2">
        <AppFooter></AppFooter>
      </div>
    </DbFooter>

    <PageLoading></PageLoading>
    <TourSlotBookSelector></TourSlotBookSelector>
    <TourEditErrorModal></TourEditErrorModal>
  </DbPage>
</template>

<script setup>
import { ref } from "vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import MenuItems from "@/views/MenuItems.vue";
import TourSlotBookSelector from "@/components/tours/TourSlotBookSelector.vue";
import PageLoading from "@/components/PageLoading.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import TourEditErrorModal from "@/components/TourEditErrorModal.vue";

const route = useRoute();
const activePage = (page) => {
  return route.name === page;
};

const isWhitePage = computed(() => {
  return activePage("profile") || activePage("license-plate");
});
</script>
